
  import { defineComponent, PropType } from 'vue';

  import { TStorePaths } from '@/common/types/storePaths';

  import { TAnalyticsNotesFilter } from '../../types/analytics-notes';
  import AnalyticsNotesImportExportTable from './AnalyticsNotesImportExportTable.vue';

  export default defineComponent({
    name: 'AnalyticsNotesProductsTable',
    components: {
      AnalyticsNotesImportExportTable,
    },
    props: {
      filter: {
        type: Object as PropType<TAnalyticsNotesFilter>,
        required: true,
      },
      isExport: {
        type: Boolean,
      },
      storePaths: {
        type: Object as PropType<TStorePaths>,
        required: true,
      },
      isMonthly: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      getTitle() {
        const exportImportWord = this.isExport ? 'экспортные' : 'импортные';

        return `Основные ${exportImportWord} товары`;
      },
    },
  });
